import { render, staticRenderFns } from "./ObjectProperty.vue?vue&type=template&id=2d74e2fd"
import script from "./ObjectProperty.vue?vue&type=script&lang=js"
export * from "./ObjectProperty.vue?vue&type=script&lang=js"
import style0 from "./ObjectProperty.vue?vue&type=style&index=0&id=2d74e2fd&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports